import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { TiVoAppProvider } from "./types";

export const usePatchProvider = (id?: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<
    ApiResponse<TiVoAppProvider>,
    Error,
    Partial<TiVoAppProvider>
  >({
    mutationFn: async (data) => {
      return await dispatch(
        apiThatThrows.patchTiVoProvider.action({
          params: { id },
          options: {
            body: JSON.stringify({
              data: {
                type: "TiVoAppProvider",
                attributes: data,
              },
            }),
          },
        })
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
      queryClient.invalidateQueries({ queryKey: ["provider", id] });
    },
  });
};
